if (!customElements.get('crftop-discovery')) {
  customElements.define('crftop-discovery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = [...this.querySelectorAll('[data-discovery-card]')];
      this.tabs = [...this.querySelectorAll('[data-discovery-tab]')];
      this.cards.forEach(card => {
        const trigger = card.querySelector('[data-discovery-trigger]');
        trigger?.addEventListener('click', () => this.expand(card), options);
        card.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && matchMedia('(min-width: 750px) and (hover: hover)').matches) {
            if (this.cards.some(other => other !== card && other.contains(document.activeElement))) return;
            this.expand(card);
          }
        }, options);
        card.addEventListener('focusin', () => this.expand(card), options);
      });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(this.tabs[next]);
          this.tabs[next].focus({ preventScroll: true });
          this.tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-discovery-panel]');
        const card = event.target.closest('[data-discovery-card]');
        if (panel) this.select(this.tabs.find(tab => tab.getAttribute('aria-controls') === panel.id));
        if (card) this.expand(card);
      }, options);
    }

    expand(active) {
      this.cards.forEach(card => {
        const selected = card === active;
        card.classList.toggle('is-active', selected);
        card.querySelector('[data-discovery-trigger]')?.setAttribute('aria-expanded', String(selected));
        const detail = card.querySelector('.cft-discovery-detail');
        if (detail) detail.hidden = !selected;
      });
    }

    select(active) {
      if (!active) return;
      this.tabs.forEach(tab => {
        const selected = tab === active;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panel = this.querySelector(`[id="${CSS.escape(tab.getAttribute('aria-controls'))}"]`);
        if (!panel) return;
        panel.hidden = !selected;
        if (!selected) panel.querySelectorAll('video').forEach(video => video.pause());
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
